import './Button.scss'
import { IconName } from '../Theme'
import { Icon } from '../Icon'
import { Loading } from '../Loading'

// TODO memo() to configure as pure with shallow comparisons
//  https://reactjs.org/docs/react-api.html#reactmemo

export const ButtonThemes = ['default', 'orange', 'tangerine', 'yellow', 'rose', 'grey', 'dark', 'white'] as const
export type ButtonTheme = (typeof ButtonThemes)[number]

export type ButtonProps = {
  text: string
  theme?: ButtonTheme
  type?: 'button' | 'submit' | 'reset' // ✅ Added type prop with allowed values
  disabled?: boolean
  loading?: boolean
  leftIcon?: IconName
  rightIcon?: IconName
  size?: 'normal' | 'table'
  table?: boolean
  active?: boolean
  onClick?: () => void
}

export function Button({
  text,
  theme = 'orange',
  type = 'button', // ✅ Default type is 'button'
  disabled = false,
  loading = false,
  leftIcon,
  rightIcon,
  table,
  active,
  onClick,
}: ButtonProps) {
  const classes = ['button', `theme-${theme}`, table ? 'table' : '', active ? 'active' : ''].filter(Boolean).join(' ')

  return (
    <button
      className={classes}
      type={type} // ✅ Added type to button element
      disabled={disabled}
      onClick={onClick}
    >
      {loading ? (
        <Loading />
      ) : (
        <>
          {leftIcon && <Icon icon={leftIcon} />}
          <span>{text ?? 'Button'}</span>
          {rightIcon && <Icon icon={rightIcon} />}
        </>
      )}
    </button>
  )
}

export default Button
